<template>
  <el-row>
    <el-form label-width="130px">
      <el-row :gutter="50" v-if="form.type == 0">
        <h4>TLC方法</h4>
        <el-row>
          <el-col :span="6">
            <el-form-item label="TLC类型:">
              {{ form.tlc.tlcLabel }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="显色方式:">
              {{ this.getColorType(form.tlc.tlcColorType) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="TLC图片:">
            <img
              v-if="form.tlc.tlcPic != ''"
              :src="'data:image/png;base64,' + form.tlc.tlcPic"
              class="img-border img-size"
            />
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="展开剂信息:">
            <el-col
              :span="20"
              v-if="SolventList.length > 0 && SolventList[0].Percent != ''"
            >
              <el-table :data="SolventList" style="width: 100%">
                <el-table-column label="溶剂" prop="Solvent"></el-table-column>
                <el-table-column label="%" prop="Percent"></el-table-column>
              </el-table>
              <el-form-item label="备注:">
                {{ form.tlc.remark }}
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row v-if="RFList.length > 0 && RFList[0].Value != ''">
          <el-form-item label="正相参数信息:">
            <el-form label-width="60px">
              <el-table :data="RFList" style="width: 100%">
                <el-table-column label="">
                  <template slot-scope="scope">
                    <span>{{ `RF${scope.$index + 1}` }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="是否为目标物">
                  <template slot-scope="scope">
                    <input
                      type="checkbox"
                      v-model="scope.row.RFFlag"
                      true-value="1"
                      false-value="0"
                      disabled
                    />
                  </template>
                </el-table-column>
                <el-table-column label="RF数值" prop="Value"></el-table-column>
              </el-table>
            </el-form>
          </el-form-item>
        </el-row>
      </el-row>
      <el-row :gutter="50" v-if="form.type == 1">
        <h4>HPLC方法</h4>
        <el-row>
          <el-col :span="8">
            <el-form-item label="名称:">
              {{ form.hplc.flashColumn.analysis_column }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流速:">
              {{
                form.hplc.flashColumn.flow_rate != ""
                  ? form.hplc.flashColumn.flow_rate + "ml/min"
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="填料粒径:">
              {{
                form.hplc.flashColumn.particle_diameter != ""
                  ? form.hplc.flashColumn.particle_diameter + "μm"
                  : ""
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="内径:">
              {{
                form.hplc.flashColumn.inner_diameter != ""
                  ? form.hplc.flashColumn.inner_diameter + "mm"
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="长度:">
              {{
                form.hplc.flashColumn.length != ""
                  ? form.hplc.flashColumn.length + "mm"
                  : ""
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="流动相A:">
              {{ form.hplc.flowA }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流动相B:">
              {{ form.hplc.flowB }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="HPLC图片:">
              <img
                v-if="form.hplc.hplcPic != ''"
                :src="'data:image/png;base64,' + form.hplc.hplcPic"
                class="img-border img-size"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="RTList.length > 0 && RTList[0].Percent != null">
          <el-form-item label="反相参数信息:">
            <el-form label-width="60px">
              <el-table :data="RTList" style="width: 100%">
                <el-table-column label="">
                  <template slot-scope="scope">
                    <span>{{ `RT${scope.$index + 1}` }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="时间" prop="Time"> </el-table-column>
                <el-table-column
                  label="百分比"
                  prop="Percent"
                ></el-table-column>
              </el-table>
            </el-form>
          </el-form-item>
        </el-row>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
export default {
  name: "GetOriginMethods",
  data() {
    console.log("GetOriginMethods", this.$store.state.sepaMethods,this.form)
    return {
      tlcTypeLabel: "",
      columnFillerType: this.$store.state.sepaMethods.columnFillerType,
      TLCType: this.$store.state.sepaMethods.TLCType,
      FlowPhase: this.$store.state.sepaMethods.FlowPhase,
      FlowPhaseList: [],
      tlcColorOptions: [
        { value: 1, label: "紫外荧光" },
        { value: 2, label: "磷钼酸" },
        { value: 3, label: "碘粉" },
        { value: 4, label: "香草醛" },
        { value: 5, label: "高锰酸钾" },
        { value: 6, label: "溴甲酚绿" },
        { value: 7, label: "重铬酸盐" },
        { value: 8, label: "硫酸-磷钨酸" },
        { value: 9, label: "茚三酮" },
        { value: 0, label: "其他" },
      ],
    };
  },
  created() {
    this.tlcTypeLabel = this.form.tlc.tlcLabel ? this.form.tlc.tlcLabel : "";
    // if (this.form.hplc.flowPhase && this.form.hplc.flowPhase.length > 0) {
    //     this.form.hplc.flowPhase.forEach((item) => {
    //         this.FlowPhaseList.push(this.FlowPhase.find(val => val.value == item).label)
    //     })
    // }
  },
  props: {
    form: {},
    RFList: {},
    RTList: {},
    SolventList: {},
  },
  methods: {
    getColorType(type) {
        console.log(!type);
      if (type==='0') {
        return this.form.tlc.tlcColor;
      } else {
        return this.tlcColorOptions.find((val) => val.value == type).label;
      }
    },
  },
};
</script>

<style scoped>
@import "../../../assets/element-component.css";
</style>
